import React, { useRef, useState } from "react";

const VeryficationCKYC = (props) => {
    const [IsRedirectionSuccess, setRedirectionSuccess] = useState(false);
    const setRedirection = () => {
        window.open(props.URL, "_blank");
        setRedirectionSuccess(true)
    }
    const getCKYCData = () => {
            props.onKYCSubmit({
                IsRedirectUrl: true,
                IsUploadFile:false
            });
        
    }
    return <>
        <div className="modal fade show CkycUploadDOCVerify" id="exampleModalDefault" style={{ display: "block" }} tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content CkycUploadDOC">
                    <div className="modal-header d-block">
                        <h1 className="modal-title fs-5" id="exampleModalLabel">No KYC Details Found!</h1>
                        <button type="button" className="close" onClick={() => props.closeKYC(false)}>X</button>
                    </div>
                    <div className="modal-body">
{/*                        {IsRedirectionSuccess ? <>
                            <img className="VeryficationCKYC" src={require("../../SMCinsuranceComponents/assets/img/POS_IMG/verify-me.webp")} />
                            <p>You have to complete your KYC</p>
                            <button onClick={props.onKYCSubmit} className="btn fileUploadBtn">Submit</button>
                        </> :
                            <div className="UIM_After03">
                                <button type="button" className="close" onClick={() => setRedirectionSuccess(true)}>X</button>
                                <iframe ref={iframeRef} src={props.URL}></iframe>
                            </div>}*/}

                        <img className="VeryficationCKYC" src={require("../Images/verify-me.webp")} />
                        <p>You have to complete your KYC</p>
                        {IsRedirectionSuccess ? <button onClick={getCKYCData} className="btn fileUploadBtn" >Submit</button> : <button onClick={setRedirection} className="btn fileUploadBtn">Verify My Identity</button>}
                    </div>
                </div>
            </div>
        </div>


    </>
}
export default VeryficationCKYC;